import { Controller, useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { GroupBase } from 'react-select'
import clsx from 'clsx'

import { SelectOption } from 'Components/Select/Select.types'
import { SelectAsync } from 'Components/SelectAsync/SelectAsync'

import { FieldSelectAsyncProps } from './Field.types'
import { parseLabel } from './Field.utils'

export const FieldSelectAsync = <
  Option extends SelectOption,
  IsMulti extends boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: FieldSelectAsyncProps<Option, IsMulti, Group>,
) => {
  const { name, selectProps, placeholder, hasError, e2eSelector } = props
  const { control } = useFormContext()
  const intl = useIntl()

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { ref, onChange, ...field } }) => (
        <SelectAsync
          ref={ref}
          {...field}
          {...selectProps}
          className={clsx(
            hasError && 'ReactSelect--hasError is-invalid',
            selectProps?.className,
          )}
          inputId={name}
          instanceId={e2eSelector}
          onChange={(selected, actionMeta) =>
            typeof selectProps?.onChange === 'function'
              ? onChange(selectProps?.onChange(selected, actionMeta))
              : onChange(selected, actionMeta)
          }
          placeholder={parseLabel(intl, placeholder)}
        />
      )}
    />
  )
}
